import zizziFonts from 'assets/fonts';

const cssBaseline = {
  MuiCssBaseline: {
    styleOverrides: {
      zizziFonts,

      html: { height: '100%' },
      body: { height: '100%' },
      '#root': { height: '100%' },
    },
  },
};

export default cssBaseline;
